import { StatusCodes } from 'http-status-codes';
const isSuccessCode = (code: number): boolean => {
  return code <= StatusCodes.MULTI_STATUS;
};

export default isSuccessCode;
